import { MatDateFormats, MAT_DATE_FORMATS } from '@angular/material/core';

export const MY_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: 'DD/MM/YYYY', // Định dạng đầu vào
    },
    display: {
        dateInput: 'DD/MM/YYYY', // Định dạng hiển thị
        monthYearLabel: 'MMMM YYYY', // Label cho tháng/năm
        dateA11yLabel: 'LL', // Accessibility
        monthYearA11yLabel: 'MMMM YYYY', // Accessibility
    },
};